import { keyBy } from '../../../helpers/common'
import {
  CORPORATE_TYPE,
  CRITERIA_GROUP,
  FINANCIAL_TYPE,
  INDICATOR_ID,
  INDICATOR_TYPE,
  OTHER_DATA,
} from './constant'

export const isNumeric = (value) => !isNaN(value) && !isNaN(parseFloat(value))

export const getCurrentTime = () => {
  return new Date().getTime()
}

export const handleScreeningIndicatorResponse = (state, data) => {
  const basicInformation = []
  const corporateBalanceSheet = []
  const bankBalanceSheet = []
  const securitiesBalanceSheet = []
  const insuranceBalanceSheet = []
  const corporateIncomeStatement = []
  const bankIncomeStatement = []
  const securitiesIncomeStatement = []
  const insuranceIncomeStatement = []
  const corporateCashflowStatement = []
  const bankCashflowStatement = []
  const securitiesCashflowStatement = []
  const insuranceCashflowStatement = []
  const corporateRatios = []
  const bankRatios = []
  const securitiesRatios = []
  const insuranceRatios = []

  data.forEach((item) => {
    if (item.parentScreeningIndicatorId === item.screeningIndicatorById) return

    switch (item.parentScreeningIndicatorId) {
      case INDICATOR_ID.BASIC_INFORMATION:
        basicInformation.push(item)
        break
      case INDICATOR_ID.CORPORATE_BALANCESHEET:
        corporateBalanceSheet.push(item)
        break
      case INDICATOR_ID.BANK_BALANCESHEET:
        bankBalanceSheet.push(item)
        break
      case INDICATOR_ID.SECURITIES_BALANCESHEET:
        securitiesBalanceSheet.push(item)
        break
      case INDICATOR_ID.INSURANCE_BALANCESHEET:
        insuranceBalanceSheet.push(item)
        break
      case INDICATOR_ID.CORPORATE_INCOMESTATEMENT:
        corporateIncomeStatement.push(item)
        break
      case INDICATOR_ID.BANK_INCOMESTATEMENT:
        bankIncomeStatement.push(item)
        break
      case INDICATOR_ID.SECURTIES_INCOMESTATEMENT:
        securitiesIncomeStatement.push(item)
        break
      case INDICATOR_ID.INSURANCE_INCOMESTATEMENT:
        insuranceIncomeStatement.push(item)
        break
      case INDICATOR_ID.CORPORATE_CASHFLOWSTATEMENT:
        corporateCashflowStatement.push(item)
        break
      case INDICATOR_ID.BANK_CASHFLOWSTATEMENT:
        bankCashflowStatement.push(item)
        break
      case INDICATOR_ID.SECURITIES_CASHFLOWSTATEMENT:
        securitiesCashflowStatement.push(item)
        break
      case INDICATOR_ID.INSURANCE_CASHFLOWSTATEMENT:
        insuranceCashflowStatement.push(item)
        break
      case INDICATOR_ID.CORPORATE_RATIOS:
        corporateRatios.push(item)
        break
      case INDICATOR_ID.BANK_RATIOS:
        bankRatios.push(item)
        break
      case INDICATOR_ID.SECURITIES_RATIOS:
        securitiesRatios.push(item)
        break
      case INDICATOR_ID.INSURANCE_RATIOS:
        insuranceRatios.push(item)
        break
      default:
        break
    }
  })

  state.basicInformation = basicInformation
  state.financials[CORPORATE_TYPE.CORPORATE][FINANCIAL_TYPE.BALANCE_SHEET] =
    corporateBalanceSheet
  state.financials[CORPORATE_TYPE.BANK][FINANCIAL_TYPE.BALANCE_SHEET] =
    bankBalanceSheet
  state.financials[CORPORATE_TYPE.SECURITIES][FINANCIAL_TYPE.BALANCE_SHEET] =
    securitiesBalanceSheet
  state.financials[CORPORATE_TYPE.INSURANCE][FINANCIAL_TYPE.BALANCE_SHEET] =
    insuranceBalanceSheet
  state.financials[CORPORATE_TYPE.CORPORATE][FINANCIAL_TYPE.INCOME_STATEMENT] =
    corporateIncomeStatement
  state.financials[CORPORATE_TYPE.BANK][FINANCIAL_TYPE.INCOME_STATEMENT] =
    bankIncomeStatement
  state.financials[CORPORATE_TYPE.SECURITIES][FINANCIAL_TYPE.INCOME_STATEMENT] =
    securitiesIncomeStatement
  state.financials[CORPORATE_TYPE.INSURANCE][FINANCIAL_TYPE.INCOME_STATEMENT] =
    insuranceIncomeStatement
  state.financials[CORPORATE_TYPE.CORPORATE][
    FINANCIAL_TYPE.CASHFLOW_STATEMENT
  ] = corporateCashflowStatement
  state.financials[CORPORATE_TYPE.BANK][FINANCIAL_TYPE.CASHFLOW_STATEMENT] =
    bankCashflowStatement
  state.financials[CORPORATE_TYPE.SECURITIES][
    FINANCIAL_TYPE.CASHFLOW_STATEMENT
  ] = securitiesCashflowStatement
  state.financials[CORPORATE_TYPE.INSURANCE][
    FINANCIAL_TYPE.CASHFLOW_STATEMENT
  ] = insuranceCashflowStatement
  state.financials[CORPORATE_TYPE.CORPORATE][FINANCIAL_TYPE.RATIOS] =
    corporateRatios
  state.financials[CORPORATE_TYPE.BANK][FINANCIAL_TYPE.RATIOS] = bankRatios
  state.financials[CORPORATE_TYPE.SECURITIES][FINANCIAL_TYPE.RATIOS] =
    securitiesRatios
  state.financials[CORPORATE_TYPE.INSURANCE][FINANCIAL_TYPE.RATIOS] =
    insuranceRatios

  state.screeningIndicatorById = keyBy(data, 'screeningIndicatorId')
  state.loading.indicator = false
}

export const convertTreeData = (dataArr) => {
  const data = keyBy(
    dataArr.map((e) => ({ ...e, children: {} })),
    'id',
  )

  dataArr
    .slice()
    .reverse()
    .forEach((e) => {
      if (data[e.parentId]) {
        data[e.parentId].children[e.id] = data[e.id]
        delete data[e.id]
      }
    })

  return data
}

export const formatParamsGetResult = ({ criteria, screeningIndicatorById }) => {
  const criterias = []

  const currency = criteria[OTHER_DATA].currency

  const formatValueGroup = (indicators) => {
    indicators
      .filter(Boolean)
      .sort((a, b) => a.createdAt - b.createdAt)
      .forEach((item) => {
        const indicatorType = item.indicatorType
        const queryHandler =
          screeningIndicatorById[item.screeningIndicatorId]?.queryHandler
        const value = formatValueIndicator({
          indicatorType,
          queryHandler,
          data: item.data,
          currency,
        })
        if (value) {
          criterias.push({
            screeningIndicatorId: item.screeningIndicatorId,
            value,
          })
        }
      })
  }

  // Basic Information
  formatValueGroup(Object.values(criteria[CRITERIA_GROUP.BASIC_INFORMATION]))

  // Industry
  const screeningIndicatorIndustryId =
    INDICATOR_ID[criteria[CRITERIA_GROUP.INDUSTRY].industryType]
  if (
    screeningIndicatorIndustryId &&
    criteria[CRITERIA_GROUP.INDUSTRY].ids.length
  ) {
    criterias.push({
      screeningIndicatorId: screeningIndicatorIndustryId,
      value: criteria[CRITERIA_GROUP.INDUSTRY].ids,
    })
  }

  // Financials
  formatValueGroup(Object.values(criteria[CRITERIA_GROUP.FINANCIALS]))

  return { criterias }
}

const formatValueIndicator = ({
  indicatorType,
  queryHandler,
  data,
  currency,
}) => {
  let value = []

  switch (queryHandler) {
    case 'MultiMatch':
    case 'Terms':
      if (indicatorType === INDICATOR_TYPE.DropdownList) {
        Object.keys(data || {}).forEach((key) => {
          if (data[key]) value.push(Number(key) ? Number(key) : key)
        })
      } else {
        Object.values(data || {})
          .filter(Boolean)
          .forEach((item) => {
            if (item.value) value.push(item.value)
          })
      }
      break
    case 'BusinessAge':
    case 'NumericRange':
      Object.values(data || {})
        .filter(Boolean)
        .forEach((item) => {
          const { from, to } = item
          if (!isNumeric(from) && !isNumeric(to)) return
          const data = {}
          if (isNumeric(from)) data.from = from
          if (isNumeric(to)) data.to = to
          value.push(data)
        })
      break
    case 'DateTimeRange':
      Object.values(data || {})
        .filter(Boolean)
        .forEach((item) => {
          const { from, to } = item
          if (!from && !to) return
          const data = {}
          if (from) data.from = from
          if (to) data.to = to
          value.push(data)
        })
      break
    case 'BooleanTerms':
      value = data
      break
    case 'FinancialRange':
      Object.values(data || {})
        .filter(Boolean)
        .forEach((item) => {
          const { year, from, to } = item
          if (!year || (!isNumeric(from) && !isNumeric(to))) return
          const data = { year, currency }
          if (isNumeric(from)) data.from = from
          if (isNumeric(to)) data.to = to
          value.push(data)
        })
      break
    case 'RatioRange':
      Object.values(data || {})
        .filter(Boolean)
        .forEach((item) => {
          const { year, from, to } = item
          if (!year || (!isNumeric(from) && !isNumeric(to))) return
          const data = { year }
          if (isNumeric(from)) data.from = from
          if (isNumeric(to)) data.to = to
          value.push(data)
        })
      break
    case 'Location':
      value = data
      break
    default:
      break
  }

  return value && value.length ? value : undefined
}
